import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { apiURL } from "@common/constants";
import { apiEndpoints } from '@common/constants';
import { ApiProvider } from '@providers/common/api.service';


@Injectable({
  providedIn: 'root'
})
export class ReportListProvider {
  http = inject(HttpClient);
  private api = inject(ApiProvider);

  rptList: any;

  getList(idType: any) {

    const request: any = {
      'idType': idType
    };

    return new Promise((resolve, reject) => {
      const endpoint = apiEndpoints.getReportList;
      this.api.post(endpoint, request, apiURL).subscribe({
        next: (data: any) => {
          if (data.ErrorMessage) {
            reject(data.ErrorMessage);
          } else {
            this.rptList = data ? data : {};
            resolve(this.rptList);
          }
        },
        error: (error: HttpErrorResponse) => {
          reject(error.status + " " + error.statusText);
        },
      })
    });
  }

}
